import { render, staticRenderFns } from "./RoleDetail.vue?vue&type=template&id=6da1df68&"
import script from "./RoleDetail.vue?vue&type=script&lang=ts&"
export * from "./RoleDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports